import { get } from './fetchUtil';
import { getGroupsApiUrl } from './pathsUtil';

export type GroupMemberRole = 'owner' | 'admin' | 'user';

export interface GroupPolicySet {
  [action: string]: string[];
}

export interface Group {
  groupId: string; // Primary key (UUID)
  ownerId: string; // Group owner (Cognito user sub)
  ownerName: string; // Group owner full name
  ownerEmail?: string; // Group owner email
  name?: string; // Group name
  serviceId: string; // Service that created the group, e.g. "w3s-comments"
  resourceId?: string; // Attached resource within the service, e.g. threadId or spaceId
  refs: string[]; // Set of unique references to resources that are using the group, as "<serviceId>/<resourceId>" strings
  refCount: number; // Number of references to the group
  metadata?: Record<string, any>; // Service-specific metadata as Record<string,any>
  systemMetadata?: Record<string, any>; // Service-specific system metadata, not editable by end-users
  policySet: GroupPolicySet; // Group policy set for this group
  managedPolicySetIds: string[]; // List of managed policy set IDs that apply to this group (enum ManagedGroupPolicySetId)
  ownerServiceId: string; // Automatically concatenated "ownerId/serviceId" string
  serviceResourceId?: string; // Automatically concatenated "serviceId/resourceId" string
  createdAt: string; // ISO timestamp when group created
  updatedAt: string; // ISO timestamp when group updated
}

export interface GroupMember {
  groupId: string; // Primary key (UUID)
  memberId: string; // Sort key (Cognito user sub)
  role: GroupMemberRole; // Role identifier ("owner", "admin", "user")
  name: string; // Real name of user (used e.g. for tagging / autocomplete)
  email?: string; // Email address of user (NOT SURE IF THIS WILL BE NEEDED)
  serviceId: string; // Service that created the group, e.g. "w3s-comments"
  resourceId?: string; // Attached resource within the service, e.g. threadId or spaceId
  serviceResourceId?: string; // Automatically concatenated "serviceId/resourceId" string
  roleName: string; // Automatically concatenated "role/name" string for GSI sorting
  metadata?: Record<string, any>; // Service-specific metadata as Record<string,any>
  systemMetadata?: Record<string, any>; // Service-specific system metadata, not editable by end-users
  createdAt: string; // ISO timestamp when member created
  updatedAt: string; // ISO timestamp when member updated
}

export interface MemberGroup {
  group: Group;
  member: GroupMember;
}

export interface MemberGroupsResponse {
  memberGroups: MemberGroup[];
  nextToken?: string;
}

export async function fetchMemberGroups() {
  const response = await get<MemberGroupsResponse>(`${getGroupsApiUrl()}/groups-api/member-groups`);
  return response.data;
}
